import { render, staticRenderFns } from "./tipping.vue?vue&type=template&id=78b9d188&lang=pug"
import script from "./tipping.vue?vue&type=script&lang=coffee"
export * from "./tipping.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports